

<div>
       <iframe [src]="safeUrl" width="100%" height="100%" frameBorder="0" ></iframe></div>
